module.exports = __webpack_public_path__ + "static/media/option_b.8a5c734d.png";